import UserAccessGroupsList from './UserAccessGroupsList';

export default UserAccessGroupsList;
